import axios from '@/lib/axios';
import { OrderAllocatedExpense, PaymentTask } from '@/hooks/api/models';
import { useMutation } from '@tanstack/react-query';

/**
 * 1194. 支払タスクプロジェクト按分費用編集
 * [PUT] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:task_id/order_allocated_expenses/:id
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
  id: number;
  amount: number;
};

const updateOrderAllocatedExpense = (props: Props): Promise<OrderAllocatedExpense> => {
  return axios.put(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/order_allocated_expenses/${props.id}`,
    props
  );
};

export const useUpdateOrderAllocatedExpense = () => {
  return useMutation({
    mutationFn: updateOrderAllocatedExpense,
  });
};
